import './flowkit.css';

export function BhFlowNode({ selected = false, icon = null, className = '', attachments = null, children }) {
  const cls = `bh-flow-node${selected ? ' bh-flow-node-selected' : ''}${className ? ' ' + className : ''}`;
  return (
    <div className={cls}>
      {attachments}
      {icon ? <span className="bh-flow-node-icon">{icon}</span> : null}
      <div className="bh-flow-node-main">{children}</div>
    </div>
  );
}

export function BhFlowTitle({ clamp = false, children }) {
  return <div className={`bh-flow-node-title${clamp ? ' bh-flow-node-title-clamp' : ''}`}>{children}</div>;
}

export function BhFlowSubtitle({ tone = 'muted', children }) {
  const cls = `bh-flow-node-subtitle${tone === 'pink' ? ' bh-flow-node-subtitle-pink' : ''}`;
  return <div className={cls}>{children}</div>;
}

export function BhFlowTags({ children }) {
  return <div className="bh-flow-node-tags">{children}</div>;
}

export function BhFlowTag({ status = null, children }) {
  return (
    <span className="bh-flow-node-tag">
      {status ? <span className={`bh-flow-node-tag-dot bh-status-${status}`} /> : null}
      <span className="bh-flow-node-tag-text">{children}</span>
    </span>
  );
}

export default BhFlowNode;
